exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-40499636]{padding:15px 15px 0 15px;background-color:#ffffff;border-radius:0 0 10px 10px}.child_page[data-v-40499636]{padding:15px}.over_address[data-v-40499636]{text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:4;line-clamp:4;-webkit-box-orient:vertical}\n", ""]);

// exports
